module.exports = __webpack_public_path__ + "media/svg/forbes-14b6ddcb.svg";